module.exports = __webpack_public_path__ + "static/media/profile-frame-right.f1dd9d3f.svg";